import { useTranslation } from "react-i18next";
import { Button, Checkbox, Input, message, Popconfirm, Popover, Switch } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Style } from "./style";
import { useSelectedItems } from "./hook";
import RemovePopoverContent from "../PopoverContent";
import { ProjectService } from "../../../../../../../services";

export default function SelectedItem({
  item = {},
  shareInfoOptions = [],
  onChangeShareInfo = () => { },
  onChangeDisable = () => { },
  onDelete = () => { },
  conf = {},
  onChangeStatus = () => { },
  onChangeSourceName = () => { },
}) {
  const { t } = useTranslation();
  const isClient = conf?.group === 'dataClient';
  const {
    email,
    visible,
    name,
    disabled,
    setVisible,
    renderName,
    onChangeSelect,
    renderDatastakeId,
    onDeleteClick,
    deletedBeforeSave,
  } = useSelectedItems({ item, onChangeShareInfo, t, onDelete, conf });

  const onInviteBack = async () => {
    const { setLoading, data = {} } = conf;
    if (typeof setLoading === 'function') {
      try {
        setLoading(true);
        await ProjectService.inviteBack(data.id, item.authorId, item.role);
        onChangeStatus('pending');
        setLoading(false);
      } catch (err) {
        setLoading(false);
        message.error(err.message || 'Error inviting user');
      }
    }
  }

  const removeContent = (
    <RemovePopoverContent
      onConfirm={onDeleteClick}
      title={t(isClient ? 'Are you sure you want to remove this client?' : 'Are you sure you want to remove this source?')}
      body={t('Its information will be removed from the project.')}
      okText={t('Yes')}
      dismissText={t('Dismiss')}
      onClose={() => setVisible(false)}
    />
  );

  return (
    <Style>
      <div className="header-cont">
        <div className="left">
          <h4>{renderName()}</h4>
        </div>
        <div className="right">
          {item.isOwnData ? (
            <Switch checked={!disabled} onChange={() => onChangeDisable(typeof disabled === 'boolean' ? !disabled : true)} />
          ) : (
            <>
              {(item.status === 'rejected' || item.status === 'deleted')
                ? deletedBeforeSave.includes(item?.data?.id) ? null : (
                  <Popconfirm
                    placement="left"
                    title={(
                      <div style={{ maxWidth: 305 }}>{t('projectInviteBackDesc')}</div>
                    )}
                    onConfirm={() => onInviteBack()}
                    okText={t('Yes')}
                    cancelText={t('No')}
                  >
                    <Button>
                      {t('Invite Again')}
                    </Button>
                  </Popconfirm>
                ) : (
                  <Popover content={removeContent} placement="left" visible={visible}>
                    <Button className="del-btn" icon={<DeleteOutlined />} onClick={() => setVisible(true)} />
                  </Popover>
                )}
            </>
          )}
        </div>
      </div>

      <div className="info">
        {!item.isOwnData && (
          <div className="row-item column">
            <label className="label">{isClient ? t('Client Name') : t('Source Name')}</label>
            <Input
              onChange={(e) => {
                onChangeSourceName(e.target.value);
              }}
              placeholder={isClient ? t('Client Name') : t('Source Name')}
              value={item.sourceName || item?.data?.name}
            />
          </div>
        )}
        <div className="row-item">
          <div className="left">
            <label>{t('Organisation Name')}</label>
          </div>
          <div className="right">
            <label>{name}</label>
          </div>
        </div>
        <div className="row-item">
          <div className="left">
            <label>{t('Datastake ID')}</label>
          </div>
          <div className="right">
            <label>{renderDatastakeId()}</label>
          </div>
        </div>
        <div className="row-item">
          <div className="left">
            <label>{t('Email')}</label>
          </div>
          <div className="right">
            <label>{email}</label>
          </div>
        </div>
      </div>

      <div className="subjects">
        <h5 className="label">{t('Information Subjects')}</h5>
        <div className="list">
          {shareInfoOptions.map((opt) => (
            <div className="item" key={`options-${opt.value}`}>
              <Checkbox
                checked={(item.shareInfo || []).includes(opt.value)}
                onChange={(e) => onChangeSelect(e.target.checked, opt.value)}
                disabled={disabled}
              />
              <label>{opt.label}</label>
            </div>
          ))}
        </div>
      </div>
    </Style>
  );
}